import { render, staticRenderFns } from "./DatadictForTestGoogle.vue?vue&type=template&id=709e0627&scoped=true"
import script from "./DatadictForTestGoogle.vue?vue&type=script&lang=js"
export * from "./DatadictForTestGoogle.vue?vue&type=script&lang=js"
import style0 from "./DatadictForTestGoogle.vue?vue&type=style&index=0&id=709e0627&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709e0627",
  null
  
)

export default component.exports